export const getGreaterEndTime = assets => assets.reduce((latestAsset, asset) => (
  (!latestAsset || asset.endTime > latestAsset.endTime) ? asset : latestAsset
), null)?.endTime || 0
